import vuex from 'vuex';
import imovel from './imoveis/imovel';
import auth from './auth/auth';
import admin from './admin/admin';

export default new vuex.Store(
    {
        modules: {
            imovel,
            auth,
            admin
        }
    }
)